<template>
  <div v-if="displayPremiumSuspended">
    <modal :closable="false" size="lg" :backdrop-opacity=".8">
      <section class="modal-with-tabs text-center">
        <div v-if="! isTrial" class="modal-with-tabs-header errorred--text pa-4 justify-center" style="border-bottom: 3px solid">
          <span class="text-h6 uppercase font-weight-bold">{{ $t('PREMIUM.SUSPENDED.ACCOUNT_SUSPENDED') }}</span>
        </div>
        <div class="modal-with-tabs-body pa-6" style="margin-bottom: 6px;">
          <b>{{ isTrial ? $t('PREMIUM.SUSPENDED.TRIAL_EXPIRED_SINCE') : $t('PREMIUM.SUSPENDED.ACCOUNT_EXPIRED_SINCE') }} {{ $filters.moment(premiumExpireDate, 'date') }}.</b>
          <!-- Become / Renew Premium -->
          <div class="mb-4">
            <div class="mb-4">
              <b class="successgreen--text">
                {{ $t('PREMIUM.SUSPENDED.TO_KEEP_WORKING') }}
                {{ isTrial ? $t('PREMIUM.SUSPENDED.SUBSCRIBE_PREMIUM') : $t('PREMIUM.SUSPENDED.RENEW_PREMIUM') }}
              </b>
            </div>
            <!-- Premium Subscription -->
            <premium-subscription hide-package-description></premium-subscription>
          </div>
        </div>
      </section>
    </modal>
  </div>
  <div v-else-if="displayPremiumExpired">
    <v-alert type="error" class="px-12 ma-0" style="border-radius: 0">
      {{ $t('PREMIUM.SUSPENDED.ACCOUNT_EXPIRED_SINCE') }} {{ $filters.moment(premiumExpireDate, 'date') }}. {{ $t('PREMIUM.SUSPENDED.ACCOUNT_WILL_BE_SUSPENDED') }}
    </v-alert>
  </div>
</template>

<script>
  import PremiumSubscription from './PremiumSubscription';

  export default {
    components: {
      PremiumSubscription,
    },
    data() {
      return {
        premiumExpireDate: null,
      };
    },
    computed: {
      displayPremiumSuspended() {
        return this.$store.state.ui.displayPremiumSuspended;
      },
      displayPremiumExpired() {
        return this.$store.state.ui.displayPremiumExpired;
      },
      isTrial() { return this.$store.state.users.accessRight.isTrial; },
    },
    created() {
      this.$store.state.users.userPromise.then(() => {
        const { user } = this.$store.state.users;
        this.premiumExpireDate = user.company && user.company.premiumExpireDate;
      });
    },
  };
</script>
